import { render, staticRenderFns } from "./CastrAudioPlayer.vue?vue&type=template&id=afe99a6e"
import script from "./CastrAudioPlayer.vue?vue&type=script&lang=js"
export * from "./CastrAudioPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports